import { call, debounce, put } from 'redux-saga/effects';
import { ReportsActions, ReportsActionType } from './actions';
import { getReports, GetReportsResponse } from '@card/commonlib';

function* fetchReports(action: ReturnType<typeof ReportsActions.fetchStarted>) {
  try {
    const reports: GetReportsResponse = yield call(getReports, action.payload);
    yield put(ReportsActions.fetchSuccess(reports));
  } catch (error) {
    yield put(ReportsActions.fetchError(error));
  }
}

export function* reportsSagas() {
  // Debounce to avoid multiple requests when hitting next page many times in a row.
  yield debounce(500, ReportsActionType.FetchReportsStarted, fetchReports);
}
